<template>
  <select
    class="form-control m-input"
    @select="emitChangeEvent"
    @change="emitChangeEvent"
  >
    <option value="">{{ firstOption }}</option>
    <option
      v-for="status in selects"
      :key="status.id"
      :value="status.id"
      :selected="status.id === selected"
    >
      {{ status.name }}
    </option>
  </select>
</template>

<script>
export default {
  name: 'SelectContractsStatus',
  data() {
    return {
      selects: [],
      firstOption: this.first ? this.first : '',
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
  },
  methods: {
    getData() {
      this.selects = [
        { id: 2, name: 'Ativo' },
        { id: 1, name: 'Bloqueado' },
        { id: 0, name: 'Suspenso' },
        { id: 3, name: 'Pendente' },
      ];
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
